import { createFileRoute, Outlet } from "@tanstack/react-router";

// Pathless module layout: the web tree mirrors the API route and the navigation group, with no
// module name in the address.
export const Route = createFileRoute("/_authenticated/_shelby")({
  component: Outlet,
});
